import { Routes } from '@angular/router';
import { MainComponent } from './site/main/main.component';
import { JobDetailsComponent } from './site/job-details/job-details.component';
import { ErrorComponent } from './site/error/error.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: MainComponent },
  { path: 'job/:seo/:jobId', component: JobDetailsComponent },
  { path: '404', component: ErrorComponent },
  { path: '**', redirectTo: '/404', pathMatch: 'full' }
];
